import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';

class Sidebar extends Component {

    state = {
        linkFoto: `${process.env.REACT_APP_API_MHS_KRS}asset/biodata/`
    }

    render() {

        // nama 
        var namaFull = localStorage.getItem('nama');
        var nama = namaFull !== null && namaFull.split(' ').slice(0, 2).join(' ');

        return (
            <nav className="sidebar sidebar-offcanvas" id="sidebar">

                <div className="user-wrapper mt-4">
                    <img
                        className="profil-photo"
                        src={
                            localStorage.getItem('foto') == ""
                                || localStorage.getItem('foto') == null
                                || localStorage.getItem('foto') == "0"
                                ? "https://i.pinimg.com/564x/66/15/da/6615da7d0d3c74c0b538cd2974e5d4ed.jpg"
                                : this.state.linkFoto + localStorage.getItem('foto')} alt="" />
                    <p className="profile-name">
                        {nama}
                        <br />
                        <span className="status-indicator online"></span>
                        &nbsp;<span style={{ opacity: '0.7' }}>online</span>
                    </p>
                </div>

                <ul className="nav">

                    <li className="nav-item">
                        <Link className="nav-link" to="/home">
                            <i className="icon-grid menu-icon" />
                            <span className="menu-title">Home</span>
                        </Link>
                    </li>

                    {
                        this.props.akses && this.props.biodata ?
                            <>
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="/biodata">
                                        <i className="ti-user menu-icon" />
                                        <span className="menu-title">Biodata</span>
                                    </a>
                                </li> */}
                                <li className="nav-item" id="akademikNav">
                                    <a className="nav-link ikon" data-toggle="collapse" href="#akademikOpen" aria-expanded="false" aria-controls="akademik" id="akademikLink">
                                        <i className="icon-book menu-icon" />
                                        <span className="menu-title">Akademik</span>
                                        <i className="menu-arrow" />
                                    </a>
                                    <div className="collapse" id="akademikOpen">
                                        <ul className="nav flex-column sub-menu">
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/krs">KRS</NavLink></li>
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/khs">KHS</NavLink></li>
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/jadwal">Jadwal Kuliah</NavLink></li>
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/presensi">Presensi</NavLink></li>
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/transkrip">Transkrip</NavLink></li>
                                            {/* <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/history-batalmk">History Batal MK</NavLink></li> */}
                                            {/*<li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/semesterpendek">Semester Pendek</NavLink></li>*/}
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item" id="akademikNav">
                                    <a className="nav-link ikon" data-toggle="collapse" href="#keuanganOpen" aria-expanded="false" aria-controls="keuangan" id="keuanganLink">
                                        <i className="ti-server menu-icon" />
                                        <span className="menu-title">Keuangan</span>
                                        <i className="menu-arrow" />
                                    </a>
                                    <div className="collapse" id="keuanganOpen">
                                        <ul className="nav flex-column sub-menu">
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/tagihan">Pembayaran</NavLink></li>
                                            <li className="nav-item"> <NavLink activeClassName="underline" className="nav-link" to="/riwayat">Riwayat Pembayaran</NavLink></li>
                                        </ul>
                                    </div>
                                </li>

                                {/* <li className="nav-item">
                                    <Link className="nav-link" to="/evaluasi">
                                        <i className="ti-bar-chart menu-icon" />
                                        <span className="menu-title">Evaluasi</span>
                                    </Link>
                                </li> */}
                                {/* <li className="nav-item">
                                    <a className="nav-link" href="https://play.google.com/store/apps/details?id=simaka.mobile&pli=1" target='_blank' rel='noreferrer'>
                                        <i className="ti-download menu-icon" />
                                        <span className="menu-title">Download Apk</span>
                                    </a>
                                </li> */}
                                {/* <li className="nav-item">
                                    <Link className="nav-link" to="/settings">
                                        <i className="ti-settings menu-icon" />
                                        <span className="menu-title">Setup Akun</span>
                                    </Link>
                                </li> */}
                            </>
                            : null
                    }
                </ul>
            </nav>
        );
    }
}

export default Sidebar;
